<!--  -->
<template>
  <div>
    <div class="cont_r_b11">
      <p>
        <img :src="images.lxth">
      </p>
      <p>
        <br>
      </p>
      <p>
        <br>
      </p>
      <p>
        <b>
          <span style="font-size:18px;font-family:宋体;">Continues Annealing Furnace</span>
        </b>
      </p>
      <p>
        <span style="font-size:12.0pt;font-family:Arial;">&nbsp;</span>
      </p>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      images: {
        lxth: require("../../../assets/img/common/lxth.jpg")
      }
    };
  },

  components: {},

  methods: {}
};
</script>
<style lang='stylus' rel='stylesheet/stylus'>
</style>


// WEBPACK FOOTER //
// src/components/en/device/lxth.vue